/* My Homepeel · VIP early access. Never stores or sends personal data anywhere except the Klaviyo
   subscribe call itself. Device flag only: localStorage mh_vip_v1 = "1". */
(function () {
  var root = document.getElementById('mh-vip');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('mh-vip-data').textContent); } catch (e) {}
  var KEY = 'mh_vip_v1';
  var done = root.querySelector('[data-mhv-done]');
  function joined(fresh) {
    root.classList.add('is-joined');
    if (done) { done.hidden = false; }
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    if (fresh) track();
  }
  function track() {
    var src = 'my_homepeel';
    if (cfg.ga4 && typeof window.gtag === 'function') { try { window.gtag('event', 'vip_join', { source: src }); } catch (e) {} }
    if (cfg.ga4 && window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { try { Shopify.analytics.publish('vip_join', { source: src }); } catch (e) {} }
    if (cfg.metaLead && typeof window.fbq === 'function') {
      try { window.fbq('track', 'Lead', { content_name: 'VIP early access', content_category: src }, { eventID: 'vip-' + Math.random().toString(36).slice(2, 12) }); } catch (e) {}
    }
  }
  var seen = false;
  try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
  if (seen && !root.classList.contains('is-closed')) joined(false);
  // Optional preview of the joined state on the hidden copy only: ?mh_vip=joined (no data in the URL).
  if (/[?&]mh_vip=joined\b/.test(location.search) && window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') { root.classList.add('is-joined'); if (done) done.hidden = false; }

  if (cfg.mode === 'embed') {
    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail; if (!d) return;
      if (d.type === 'submit' && String(d.formId) === String(cfg.formId)) joined(true);
    });
    return;
  }

  var form = root.querySelector('form[data-mhv-form]');
  if (!form) return;
  var email = form.querySelector('#mhv-email'), phone = form.querySelector('#mhv-phone');
  var sms = form.querySelector('[data-mhv-sms]'), msg = form.querySelector('[data-mhv-msg]'), btn = form.querySelector('button[type=submit]');
  phone.addEventListener('input', function () { sms.hidden = !phone.value.trim(); });
  function auPhone(v) {
    v = v.replace(/[\s().-]/g, '');
    if (!v) return '';
    if (/^04\d{8}$/.test(v)) return '+61' + v.slice(1);
    if (/^614\d{8}$/.test(v)) return '+' + v;
    if (/^\+\d{8,15}$/.test(v)) return v;
    return null;
  }
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    msg.textContent = '';
    email.removeAttribute('aria-invalid'); phone.removeAttribute('aria-invalid');
    var em = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { email.setAttribute('aria-invalid', 'true'); msg.textContent = 'Please check your email address.'; email.focus(); return; }
    var ph = auPhone(phone.value);
    if (ph === null) { phone.setAttribute('aria-invalid', 'true'); msg.textContent = 'Please check your mobile number, or leave it blank.'; phone.focus(); return; }
    if (cfg.mode !== 'list' || !cfg.listId || !cfg.companyId) {
      msg.textContent = 'Preview only: this sign-up is not connected yet, so nothing was sent.';
      return;
    }
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    var attrs = { email: em, subscriptions: subs };
    if (ph) { attrs.phone_number = ph; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
    var body = { data: { type: 'subscription', attributes: { custom_source: cfg.source || 'My Homepeel', profile: { data: { type: 'profile', attributes: attrs } } },
      relationships: { list: { data: { type: 'list', id: cfg.listId } } } } };
    btn.disabled = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body)
    }).then(function (r) {
      btn.disabled = false;
      if (r.status === 202 || r.ok) { form.reset(); sms.hidden = true; joined(true); }
      else { msg.textContent = "Sorry, that didn't go through. Please try again."; }
    }).catch(function () { btn.disabled = false; msg.textContent = "Sorry, that didn't go through. Please try again."; });
  });
})();
